import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as React from 'react';
import axios from "axios";

import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import Link from '@mui/material/Link';
import Breadcrumbs from '@mui/material/Breadcrumbs';

import isEmail from 'validator/lib/isEmail';
import isStrongPassword from 'validator/lib/isStrongPassword';
import isLength from 'validator/lib/isLength';
import equals from 'validator/lib/equals';

import { Swiper } from 'swiper/react';
import { SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import "./../assets/swiperCss.css";
import 'swiper/css/autoplay';

import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';

import { LoadScript, GoogleMap } from '@react-google-maps/api';

import AdminMenuComponent from "../../components/admin/AdminMenuComponent.js";

const config = require("../../constants/constants.js")

const widthPageSlide = 600;

const DoveSiamoPageComponent = ({ loginUserApiRequest, reduxDispatch, setReduxUserState }) => {
  const [validated, setValidated] = useState(false);
  const [loginUserResponseState, setLoginUserResponseState] = useState({
    success: "",
    error: "",
    loading: false,
  });

  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget.elements;

    const email = form.email.value;
    const password = form.password.value;
    const doNotLogout = form.doNotLogout.checked;

    if (event.currentTarget.checkValidity() === true && email && password) {
      setLoginUserResponseState({ loading: true });
      loginUserApiRequest(email, password, doNotLogout)
        .then((res) => {
          setLoginUserResponseState({ success: res.success, loading: false, error: "" });

          if (res.userLoggedIn) {
            reduxDispatch(setReduxUserState(res.userLoggedIn));
          }

          if (res.success === "user logged in" && !res.userLoggedIn.isAdmin) window.location.assign('/user')
          else window.location.assign('/admin/categories')

        })
        .catch((er) =>
          setLoginUserResponseState({ error: er.response.data.message ? er.response.data.message : er.response.data })
        );
    }

    setValidated(true);
  };

  const [applicativo, setApplicativo] = useState("");
  const [isShopActive, setIsShopActive] = useState("");
  const [isIconLoginActive, setIsIconLoginActive] = useState("");
  const [isApplicationWorkInProgress, setIsApplicationWorkInProgress] = useState("");
  const [showMainMenuUppercase, setShowMainMenuUppercase] = useState("");
  const [ragioneSociale, setRagioneSociale] = useState("");
  const [email, setEmail] = useState("");
  const [pageDoveSiamoLatitudine, setPageDoveSiamoLatitudine] = useState(0.0);
  const [pageDoveSiamoLongitudine, setPageDoveSiamoLongitudine] = useState(0.0);
  const [googleMapsZoom, setGoogleMapsZoom] = useState(16);

  const [isBreadcrumbActive, setIsBreadcrumbActive] = useState("");
  const [isBreadcrumbSimplePageActive, setIsBreadcrumbSimplePageActive] = useState("");
  const [breadcrumbsBackgroud, setBreadcrumbsBackgroud] = useState("");
  const [breadcrumbsColor, setBreadcrumbsColor] = useState("");
  const [menuBackground, setMenuBackground] = useState("");
  const [menuColor, setMenuColor] = useState("");
  const [menuMobileColor, setMenuMobileColor] = useState("");

  const getConfigByProgressivoApiRequest = async (progressivoRagSoc) => {
    //console.log("[getConfigByProgressivoApiRequest] leggo const con progressivo =", progressivoRagSoc);
    const url = `/api/configs/progressivo/` + progressivoRagSoc;
    const { data } = await axios.get(url);
    return data
  }

  useEffect(() => {
    getConfigByProgressivoApiRequest('0001').then((data) => {
      //console.log(`data =`, data);
      setApplicativo(data?.applicativo);
      setIsShopActive(data?.isShopActive);
      setIsIconLoginActive(data?.isIconLoginActive);
      setIsApplicationWorkInProgress(data?.isApplicationWorkInProgress);
      setShowMainMenuUppercase(data?.showMainMenuUppercase);
      setIsBreadcrumbActive(data?.isBreadcrumbActive);
      setIsBreadcrumbSimplePageActive(data?.isBreadcrumbSimplePageActive);
      setBreadcrumbsBackgroud(data?.breadcrumbsBackgroud);
      setBreadcrumbsColor(data?.breadcrumbsColor);
      setMenuBackground(data?.menuBackground);
      setMenuColor(data?.menuColor);
      setMenuMobileColor(data?.menuMobileColor);

      setRagioneSociale(data?.ragioneSociale);
      setEmail(data?.email);
      setPageDoveSiamoLatitudine(data?.pageDoveSiamoLatitudine);
      setPageDoveSiamoLongitudine(data?.pageDoveSiamoLongitudine);
      setGoogleMapsZoom(data?.googleMapsZoom);
      
      //console.log(`data?.applicativo =`, data?.applicativo);
      //console.log(`data?.linkWhatsapp =`, data?.linkWhatsapp);
      //console.log(`data?.linkFacebook =`, data?.linkFacebook);
      //console.log(`data?.linkInstagram =`, data?.linkInstagram);
      //console.log(`data?.linkTwitter =`, data?.linkTwitter);
      //console.log(`ragioneSociale =`, data?.ragioneSociale);
      //console.log(`urlCustomerImageServer =`, data?.urlCustomerImageServer);
      //console.log(`isShopActive =`, data?.isShopActive);
      //console.log(`isIconLoginActive =`, data?.isIconLoginActive);
      //console.log(`isApplicationWorkInProgress =`, data?.isApplicationWorkInProgress);
    })
      .catch((er) => {
        console.log(er);
      });
  }, [applicativo, isShopActive, showMainMenuUppercase])

  const [page, setPage] = useState({});
  const [id, setId] = useState("");
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [description, setDescription] = useState("");
  const [customizedName, setCustomizedName] = useState("");
  const [customizedStreet, setCustomizedStreet] = useState("");
  const [customizedZip, setCustomizedZip] = useState("");
  const [customizedCity, setCustomizedCity] = useState("");
  const [customizedEmail, setCustomizedEmail] = useState("");
  const [customizedTelephone, setCustomizedTelephone] = useState("");
  const [tabAttivo, setTabAttivo] = React.useState('home');

  const getPageByMenuValueApiRequest = async (menuValue) => {
    console.log("[getPageByMenuValueApiRequest] leggo page con menuValue =", menuValue);
    const url = `/api/pages/menuValue/` + menuValue;
    const { data } = await axios.get(url);
    //console.log(`data =`, data);
    return data
  }

  const containerStyle = {
    // width: '100%',
    height: '400px'
  };

  useEffect(() => {
    getPageByMenuValueApiRequest('DOVE SIAMO').then((data) => {
      //console.log(`data 1 =`, data);
      setPage(data);
      setTitle(data?.title.text);
      setSubTitle(data?.subTitle.text);
      setDescription(data?.description.text);
      setTabAttivo('home');
      setId(data?._id);
      setCustomizedName(page?.customizedContent.name.text);
      setCustomizedStreet(page?.customizedContent.street.text);
      setCustomizedZip(page?.customizedContent.zip.text);
      setCustomizedCity(page?.customizedContent.city.text);
      setCustomizedEmail(page?.customizedContent.email.text);
      setCustomizedTelephone(page?.customizedContent.telephone.text);
      //console.log(`id =`, id);
      //console.log(`page?.title.text =`, page?.title.text);
      //console.log(`page?.description.text =`, page?.description.text);
      //console.log(`page?.customizedContent =`, page?.customizedContent);
      //console.log(`page?.customizedContent.name.text =`, page?.customizedContent.zip.text);
    })
      .catch((er) => {
        console.log(er);
      });
  }, [tabAttivo, id])

  const centerGoogleMap = {
    // zoom= {10} default example
    //   zoom 20 = vedo una sola via
    //   zoom 18 = vedo via Sorte+altre vie
    //   zoom 15 = vedo prezzate .. ponte san pietro
    //   zoom 10 = vedo la lombardia
    //   zoom 3 = vedo il mondo
    // New York example
    //  lat: 40.7128, 
    //  lng: -74.0060
    // Brembate di Sopra
    //lat: 45.7166800,
    //lng: 9.5794500
    // Terno Largo Donizetti
    //lat: 45.683652,
    //lng: 9.535314

    lat: pageDoveSiamoLatitudine,
    lng: pageDoveSiamoLongitudine

    //    zoom={10}   vedo 
  };

  return (

    <Box sx={{ flexGrow: 1 }}>

      <AdminMenuComponent></AdminMenuComponent>

      <Grid
        display={isBreadcrumbSimplePageActive === 'Si' ? "block" : "none"}
        container
        size={{ xs: 12, md: 12 }}
        paddingTop={{ xs: 0, md: 0 }}
        paddingLeft={{ xs: 0, md: 0 }}
        paddingRight={{ xs: 0, md: 0 }}
        spacing={{ xs: 0, md: 0 }}
        sx={{
          //background: '#242424',        // sfondo mainMenu = nero 
          //background: '#2074d4'         // sfondo mainMenu = blu navy
          background: breadcrumbsBackgroud  // sfondo mainMenu = da configs
        }}
      >

        <Breadcrumbs
          separator="›"
          aria-label="breadcrumb"
          size={{ xs: 12, md: 4 }}
          paddingTop={{ xs: 0, md: 0 }}
          paddingLeft={{ xs: 8, md: 17 }}   // per posizione dopo logo di sx
          paddingRight={{ xs: 1, md: 0 }}
          spacing={{ xs: 0, md: 0 }}
          color="white"
          //fontFamily="Roboto"
          fontFamily="sans-serif"
          textTransform='none'
          fontSize={14}
          //fontStyle= 'italic'
          //fontWeight= {100}
        >

          <Link underline="hover" color="inherit" href="/">
            <HomeOutlinedIcon />
          </Link>

          <Typography
            sx={{
              color: 'white',
              fontFamily:"sans-serif",
              textTransform:'none',
              fontSize:14,
            }}
          >      
            {config.BC_DOVESIAMO}
          </Typography>

        </Breadcrumbs>

      </Grid>

      <Grid container spacing={{ xs: 1, md: 2 }}>

        <Grid
          size={{ xs: 0, md: 0 }}
        >
        </Grid>

        <Grid
          size={{ xs: 12, md: 8 }}
          padding={{ xs: 0, md: 4 }}
        >

          <Box sx={{ width: { md: { widthPageSlide } } }}>

            <LoadScript googleMapsApiKey={config.GOOGLE_MAPS_KEY}>
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={centerGoogleMap}
                zoom={googleMapsZoom}
              >
                {/* Map components go here */}
              </GoogleMap>
            </LoadScript>

            {/* 
            <Swiper
              style={{
                '--swiper-navigation-color': '#fff',
                '--swiper-pagination-color': '#fff',
              }}

              loop={true}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false
              }}

              lazy={true}
              pagination={{
                clickable: true,
              }}
              navigation={true}
              modules={[Pagination, Navigation, Autoplay]}
              className="image-dim"
            >

              {page.images?.map((itemImg, id) => (

              <SwiperSlide>
                <img
                  src={itemImg.path}
                  loading="lazy"
                />
                <div class="text-overlay">
                  <p>
                    <Typography variant="h6" color='#ffffff'
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1,
                        p: 0, m: 0,
                      }}
                    >
                      {itemImg.title} 
                    </Typography>
                  </p>
                  <p>
                    <Typography variant="h7" color='#dfdfde'
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 1,
                        p: 0, m: 0,
                      }}
                    >
                      {itemImg.subTitle} 
                    </Typography>
                  </p>
                </div>
                <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
              </SwiperSlide>

              ))}              

              <SwiperSlide>
                <img
                  src={pathImage2}
                  loading="lazy"
                />
                <div class="text-overlay">
                  <p>
                    <Typography variant="h6" color='#ffffff'
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1,
                        p: 0, m: 0,
                      }}
                    >
                      {titleImage2} 
                    </Typography>
                  </p>
                  <p>
                    <Typography variant="h7" color='#dfdfde'
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 1,
                        p: 0, m: 0,
                      }}
                    >
                      {subTitleImage2} 
                    </Typography>
                  </p>
                </div>
                <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
              </SwiperSlide>

            </Swiper>
          */}

          </Box>

        </Grid>

        <Grid
          size={{ xs: 12, md: 3 }}
          padding={{ xs: 1, md: 1 }}
          spacing={0}
        >

          <Box
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              height: 30
            }}
          />

          <Paper
            sx={{
              paddingTop: 0, paddingBottom: 3, paddingLeft: 2, paddingRight: 2,
              background: '#cce0e6'

            }}
            elevation={6}
          >

            <Stack
              spacing={0}
              sx={{ flexDirection: { xs: "column", md: "column" }, paddingTop: 0, paddingLeft: 0, paddingRight: 0, }}
            >

              <Typography
                sx={{
                  paddingTop: 2, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  fontFamily: 'Arial',
                  fontWeight: 500,
                  fontSize: 20,
                  color: 'navy',
                }}
              >
                <b>{customizedName}</b>
              </Typography>

              <Typography
                sx={{
                  paddingTop: 2, paddingBottom: 0, paddingLeft: 2, paddingRight: 0,
                  fontFamily: 'Arial',
                  fontWeight: 300,
                  fontSize: 16,
                  color: 'navy',
                }}
              >
                {customizedStreet}
              </Typography>

              <Typography
                sx={{
                  paddingTop: 1, paddingBottom: 0, paddingLeft: 2, paddingRight: 0,
                  fontFamily: 'Arial',
                  fontWeight: 300,
                  fontSize: 16,
                  color: 'navy',
                }}
              >
                {customizedZip}&nbsp;{customizedCity}
              </Typography>

              <Typography
                sx={{
                  paddingTop: 1, paddingBottom: 0, paddingLeft: 2, paddingRight: 0,
                  fontFamily: 'Arial',
                  fontWeight: 300,
                  fontSize: 16,
                  color: 'navy',
                }}
              >
                {customizedEmail}
              </Typography>

              <Typography
                sx={{
                  paddingTop: 1, paddingBottom: 0, paddingLeft: 2, paddingRight: 0,
                  fontFamily: 'Arial',
                  fontWeight: 300,
                  fontSize: 16,
                  color: 'navy',
                }}
              >
                {customizedTelephone}
              </Typography>

            </Stack>

          </Paper>

        </Grid>

      </Grid>

      <Box
        sx={{
          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
          height: 30
        }}
      />

    </Box>

  );
};

export default DoveSiamoPageComponent;
